import { inject, Signal } from '@angular/core';
import { AssetsStore } from '../stores/assets.store';
import { AuthStore } from '../stores/auth.store';
import { ThemeService } from './theme';
import { ResponsiveService } from './responsive';
import { v3LayoutFlags, V3LayoutFlags } from './v3-layout';
import { v3GuestMode } from './v3-guest-mode';

export interface V3ComponentContext {
  assetsStore: InstanceType<typeof AssetsStore>;
  authStore: InstanceType<typeof AuthStore>;
  themeService: ThemeService;
  responsiveService: ResponsiveService;
  layout: V3LayoutFlags;
  isGuestMode: Signal<boolean>;
}

// Bundles the inject()/v3LayoutFlags/v3GuestMode wiring self-injecting V3 components repeat.
export function v3ComponentContext(): V3ComponentContext {
  const assetsStore = inject(AssetsStore);
  const authStore = inject(AuthStore);
  const themeService = inject(ThemeService);
  const responsiveService = inject(ResponsiveService);
  return {
    assetsStore,
    authStore,
    themeService,
    responsiveService,
    layout: v3LayoutFlags(themeService, responsiveService),
    isGuestMode: v3GuestMode(themeService, authStore),
  };
}
